import { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'

import { addToast } from 'components/Toast/Toast'
import { addToPlaylist } from 'services/endpoints/media'

import Playlists from './Playlists'
import CreatePlaylist from '../CreatePlaylist/CreatePlaylist'

type PlaylistItemType = 'post' | 'message'

interface Props {
    itemId: string
    itemType: PlaylistItemType
    closeFn: () => void
}

const AddToPlaylist = ({
    itemId,
    itemType,
    closeFn
}: Props) => {
    const [newPlaylistOpen, setNewPlaylistOpen] = useState(false)
    const [selectedPlaylist, setSelectedPlaylist] = useState<string>('')
    const queryClient = useQueryClient()

    const { t } = useTranslation()

    const addItemToPlaylist = useMutation(
        async (variables: {
            playlistId: string
            itemId: string
            type: PlaylistItemType
        }) => await addToPlaylist(variables),
        {
            onSuccess: () => {
                queryClient.invalidateQueries('getMediaData')
                closeFn()
            },
            onError: () => {
                addToast(
                    'error',
                    t('error:errorSomethingWentWrong')
                )
            }
        }
    )

    return newPlaylistOpen ? (
        <CreatePlaylist
            closeFn={() => {
                if (newPlaylistOpen) {
                    setNewPlaylistOpen(false)
                }
            }}
            setSelectedPlaylist={(val: string) => {
                setSelectedPlaylist(val)
            }}
        />
    ) : (
        <Playlists
            closeFn={closeFn}
            confirmFn={() => {
                addItemToPlaylist.mutate({
                    playlistId: selectedPlaylist,
                    itemId,
                    type: itemType
                })
            }}
            addNew={() => {
                if (!newPlaylistOpen) {
                    setNewPlaylistOpen(true)
                }
            }}
            selectedPlaylist={selectedPlaylist}
            setSelectedPlaylist={(val: string) => {
                setSelectedPlaylist(val)
            }}
        />
    )
}

export default AddToPlaylist